exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".edit-row[data-v-4fb18daf] {\n  position: relative;\n}\n[data-v-4fb18daf] .edit-row .btn-wrap {\n  margin: 12px 0 32px 8px;\n}\n", ""]);

// exports
